(function ($) {
  "use strict";
  $(function () {
    const init = () => {
      scrollbarCheck();
      navScroll();
      setCurrentlyActiveNavBySectionPos();
      agentLeadFormCollapse();
    };

    const scrollbarCheck = () => {
      const containers = document.querySelectorAll(
        ".js-has-horizonal-scrollbar"
      );

      if (!containers.length) return;

      const checkScrollbar = () => {
        containers.forEach((container) => {
          if (container.scrollWidth > container.clientWidth) {
            container.classList.add("has-scrollbar");
          } else {
            container.classList.remove("has-scrollbar");
          }
        });
      };

      window.addEventListener("load", checkScrollbar);
      window.addEventListener("resize", checkScrollbar);
    };

    scrollbarCheck();

    const navScroll = () => {
      const $navLink = $(".js-item-nav-link");
      const $wpAdminBar = $(".wpadminbar");
      const $header = $(".header--agents-portal");
      const $nav = $(".project-single__navigation");

      if ($navLink.length === 0) return;

      $navLink.on("click", function (event) {
        event.preventDefault();

        const targetId = this.getAttribute("href");
        const $target = $(targetId);

        if ($target.length) {
          let offset = $target.offset().top;
          let totalOffset = 0;

          if ($wpAdminBar.length) {
            totalOffset += $wpAdminBar.outerHeight();
          }
          if ($header.length) {
            totalOffset += $header.outerHeight();
          }
          if ($nav.length) {
            totalOffset += $nav.outerHeight();
          }

          $("html").css("scroll-behavior", "auto");

          $("html, body").animate(
            {
              scrollTop: offset - totalOffset - 60,
            },
            600,
            function () {
              $("html").css("scroll-behavior", "smooth");
            }
          );
        }
      });
    };

    const setCurrentlyActiveNavBySectionPos = function () {
      const sections = document.querySelectorAll(".js-item-content");
      const navLinks = document.querySelectorAll(".js-item-nav-link");

      // Frissítjük a linkek státuszát
      const updateActiveLink = () => {
        let activeSection = null;
        let nextSection = null;
        let offset = 180;

        sections.forEach((section, index) => {
          const rect = section.getBoundingClientRect();
          const sectionTop = rect.top + window.scrollY;
          const sectionBottom = sectionTop + rect.height;

          if (
            sectionTop <= window.scrollY + offset &&
            sectionBottom > window.scrollY + offset
          ) {
            activeSection = section;
            nextSection = sections[index + 1] || null;
          }
        });

        if (!activeSection) {
          navLinks.forEach((link) => link.classList.remove("is-active"));
          return;
        }

        navLinks.forEach((link) => {
          link.classList.toggle(
            "is-active",
            link.getAttribute("href") === `#${activeSection.id}`
          );
        });
      };

      window.addEventListener("scroll", updateActiveLink);
      updateActiveLink();
    };

    const agentLeadFormCollapse = function () {
      const $ctx = $(".js-agent-lead-form");

      if ($ctx.length === 0) return;

      $ctx.find("h5").each(function (index, el) {
        if (index === 0) {
          $(el).addClass("is-expanded");
        }

        $(el).on("click", function () {
          $(this).toggleClass("is-expanded");
        });
      });
    };

    init();

    if ($(".template-agents-portal").length) {
      if ($(".js-get-project-data").length === 0) return;

      // Store promises for parallel API calls
      var promises = {
        projectsData: null,
        flatCount: null,
        freeFlats: null
      };

      // ✅ 1. Fetch project data (for bedrooms and prices)
      promises.projectsData = cordiaAPI
        .get("/sf/getprojectsdatas", {
          params: {
            lang: $.langCookie,
            sitelang: "es",
            global_sf_project_families:
              localize.global_sf_project_families || null,
            global_sf_projects: localize.global_sf_projects || null,
            global_sf_exclude: localize.global_sf_exclude || 0,
          },
        })
        .catch(function (error) {
          console.error("getprojectsdatas API Error:", error);
          return { data: { numbers: {}, names: {} } };
        });

      // ✅ 2. Fetch total units count (like SASAD)
      promises.flatCount = cordiaAPI
        .get("/sf/getresidentialflatcount", {
          params: {
            lang: $.langCookie,
          },
        })
        .catch(function (error) {
          console.error("getresidentialflatcount API Error:", error);
          return { data: {} };
        });

      // ✅ 3. Fetch available units count
      promises.freeFlats = cordiaAPI
        .get("/sf/getfreeflats", {
          params: {
            lang: $.langCookie,
          },
        })
        .catch(function (error) {
          console.error("getfreeflats API Error:", error);
          return { data: { numbers: {} } };
        });

      // Wait for all API calls to complete
      Promise.all([
        promises.projectsData,
        promises.flatCount,
        promises.freeFlats
      ]).then(function (responses) {
        var projectsData = responses[0].data.numbers || {};
        var projectsDataNames = responses[0].data.names || {};
        var flatCountData = responses[1].data || {};
        var freeFlatsData = responses[2].data.numbers || {};

        console.log("API Responses loaded:", {
          projectsData: projectsData,
          flatCountData: flatCountData,
          freeFlatsData: freeFlatsData
        });

        $(".js-get-project-data").each(function () {
          var residential = $(this).data("residential"); // Residential ID (e.g. 4066434484)
          var projects = $(this).data("projects") || []; // List of Project IDs (e.g. ["a024H00000nHmpgQAC"])
          var $parent = $(this).parent();
          var totalUnits = 0;
          var availableUnits = 0;
          var bedroomCounts = [];
          var lowestPrice = null;

          console.log(
            "Processing Residential:",
            residential,
            "Projects:",
            projects
          );

          // ✅ Calculate total units from getresidentialflatcount (like SASAD)
          if (flatCountData.hasOwnProperty(residential)) {
            const flatCount = flatCountData[residential];
            
            // Sum up counts for each project ID in the projects array
            $.each(projects, function (index, projectId) {
              if (flatCount.hasOwnProperty(projectId)) {
                totalUnits += parseInt(flatCount[projectId]) || 0;
              }
            });
          }

          // ✅ Calculate available units from getfreeflats
          if (freeFlatsData.hasOwnProperty(residential)) {
            const freeFlats = freeFlatsData[residential];
            
            // Sum up free flats for each project ID in the projects array
            $.each(projects, function (index, projectId) {
              if (freeFlats.hasOwnProperty(projectId)) {
                availableUnits += parseInt(freeFlats[projectId]) || 0;
              }
            });
          }

          // ✅ Fetch bedrooms and min_price from getprojectsdatas
          if (projectsData.hasOwnProperty(residential)) {
            var residentialData = projectsData[residential];

            // Get bedrooms list (unique values)
            if (Array.isArray(residentialData.bedrooms)) {
              bedroomCounts = residentialData.bedrooms;
            }

            // Get min price (ignore 0)
            if (
              residentialData.min_price !== null &&
              residentialData.min_price > 0
            ) {
              lowestPrice = residentialData.min_price;
            }
          }

          // Debugging output
          console.log(
            `Residential: ${residential}, Total Units: ${totalUnits}, Available Units: ${availableUnits}, Bedrooms: ${bedroomCounts.join(
              ", "
            )}, Min Price: ${lowestPrice}`
          );

          // ✅ Update Available & Total Units
          if (totalUnits > 0) {
            $(this)
              .find(".js-total-units")
              .html(
                `${totalUnits} ${$.pluralize(
                  localize.translations.pieces,
                  totalUnits
                )}`
              );
          } else {
            $(this).find(".js-total-units").html(`-`);
          }

          if (availableUnits > 0) {
            $(this)
              .find(".js-available-units")
              .html(
                `${availableUnits} ${$.pluralize(
                  localize.translations.pieces,
                  availableUnits
                )}`
              );
          } else {
            $(this).find(".js-available-units").html(`-`);
          }

          // ✅ Update Bedrooms
          if (bedroomCounts.length > 0) {
            $(this)
              .find(".js-bedrooms")
              .html(bedroomCounts.sort((a, b) => a - b).join(", "));
            
            // If we're on agent lead form, populate the rooms select
            if ($("#client-offer-rooms").length && $("#client-offer-rooms").data("agents-portal")) {
              var $roomsSelect = $("#client-offer-rooms");
              var currentRooms = $roomsSelect.html();
              
              // Only populate if empty or if we have bedroom data
              if (!currentRooms || currentRooms.trim() === '') {
                $roomsSelect.html("");
                var sortedBedrooms = bedroomCounts.sort((a, b) => a - b);
                
                sortedBedrooms.forEach(function(bedroom) {
                  var bedroomValue = bedroom;
                  var bedroomLabel = (bedroom == 1 || bedroom == 'garzon') ? '1' : bedroom;
                  $roomsSelect.append(
                    $('<option></option>')
                      .attr('value', bedroomValue)
                      .text(bedroomLabel)
                  );
                });
                
                // Reload SumoSelect if initialized
                if ($roomsSelect[0].sumo) {
                  $roomsSelect[0].sumo.reload();
                }
                
                // Hide warning message
                $(".js-room-warning").hide();
              }
            }
          } else {
            $(this).find(".js-bedrooms").html(`-`);
          }

          // ✅ Update Lowest Price
          if (lowestPrice !== null) {
            $(this)
              .find(".js-price")
              .html(
                `${lowestPrice.toLocaleString("de-DE", {
                  minimumFractionDigits: 0,
                })} €`
              );
          } else {
            $(this).find(".js-price").html(`-`);
          }

          $(this).css("opacity", "1");
        });
      }).catch(function (error) {
        console.error("API Error:", error);
      });
    }
  });
})(jQuery);
